"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AuthTokenStrategy", {
    enumerable: true,
    get: function() {
        return AuthTokenStrategy;
    }
});
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _nocodbsdk = require("nocodb-sdk");
const _passportcustom = require("passport-custom");
const _models = require("~/models");
const _utils = require("~/utils");
const _helpers = require("~/helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let AuthTokenStrategy = class AuthTokenStrategy extends (0, _passport.PassportStrategy)(_passportcustom.Strategy, 'authtoken') {
    // eslint-disable-next-line @typescript-eslint/ban-types
    async validate(req, callback) {
        try {
            let user;
            // Extract token from either xc-token header or Authorization Bearer header
            const token = (0, _helpers.getApiTokenFromHeader)(req);
            if (token) {
                const apiToken = await _models.ApiToken.getByToken(token);
                if (!apiToken) {
                    return callback({
                        msg: 'Invalid token'
                    });
                }
                user = {
                    is_api_token: true
                };
                // old auth tokens will not have fk_user_id, so we return editor role
                if (!apiToken.fk_user_id) {
                    user.base_roles = (0, _nocodbsdk.extractRolesObj)(_nocodbsdk.ProjectRoles.EDITOR);
                    return callback(null, user);
                }
                const dbUser = await _models.User.getWithRoles(req.context, apiToken.fk_user_id, _extends({
                    baseId: req['ncBaseId']
                }, req['ncWorkspaceId'] ? {
                    workspaceId: req['ncWorkspaceId']
                } : {}));
                if (!dbUser) {
                    return callback({
                        msg: 'User not found'
                    });
                }
                Object.assign(user, _extends({
                    id: dbUser.id,
                    email: dbUser.email,
                    display_name: dbUser.display_name,
                    roles: (0, _nocodbsdk.extractRolesObj)(dbUser.roles),
                    base_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.base_roles),
                    is_new_user: dbUser.is_new_user
                }, dbUser.workspace_roles ? {
                    workspace_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.workspace_roles)
                } : {}, dbUser.org_roles ? {
                    org_roles: (0, _nocodbsdk.extractRolesObj)(dbUser.org_roles)
                } : {}, {
                    // Add SSO client information from the API token if available
                    extra: await apiToken.getExtraForUserPayload()
                }));
            }
            return callback(null, (0, _utils.sanitiseUserObj)(user));
        } catch (error) {
            return callback(error);
        }
    }
};
AuthTokenStrategy = _ts_decorate([
    (0, _common.Injectable)()
], AuthTokenStrategy);
